module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/mobileAppSheet-7a889c85d930154d59d0b130ea63174b.png";